import { Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Front from "./components/Front";
import About from "./components/About";
import Services from "./components/Services";
import Policy from "./components/Policy";
import Contact from "./components/Contact";
import NotFound from "./components/NotFound";
import AboutCompany from "./components/AboutCompany";
import Terms from "./components/Terms";
import Allservices from "./components/Allservices";
import Rules from "./components/Rules";
import DeleteAccount from "./components/DeleteAccount";
import ChildSafetyPolicy from "./components/ChildSafetyPolicy";

function App() {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(255,122,61,0.18),_transparent_25%),linear-gradient(135deg,_#05070d_0%,_#0f172a_45%,_#111827_100%)] text-slate-100">
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Front />
              <About />
              <Services />
              <Allservices />
              <Contact />
            </>
          }
        />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/streams" element={<Allservices />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/aboutcompany" element={<AboutCompany />} />
        <Route path="/deleteAccount" element={<DeleteAccount />} />
        <Route path="/child-safety" element={<ChildSafetyPolicy />} />
        <Route path="/childSafetyPolicy" element={<ChildSafetyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
